import * as React from 'react';
import { PricingColumn } from './PricingColumn';
import { FeaturesMatrix } from '../FeaturesMatrix';
import { GettingStarted } from './GettingStarted';
import { PerksOfAccountBalance } from './PerksOfAccountBalance';
import { WhichPlan } from './WhichPlan';
import { BalanceCalculator } from './BalanceCalculator';
import { PricingFAQ } from './PricingFAQ';
import arrow from '../../../../../assets/images/static_pages/hand_drawn_arrow.svg';
import { v4PlanColumnDatas } from '../../../../constants/pricing';

export const Pricing = () => {
  const [togglePayPeriod, setTogglePayPeriod] = React.useState('annual');
  const [seatCount, setSeatCount] = React.useState(1);
  const { trial, lite, standard, premium } = v4PlanColumnDatas;
  const columnDatas = [trial, lite, standard, premium];
  const isMonthly = togglePayPeriod === 'monthly';
  const handleToggle = () => setTogglePayPeriod(isMonthly ? 'annual' : 'monthly');
  const columns = columnDatas.map((columnData) => (
    <PricingColumn
      key={columnData.name}
      seatCount={seatCount}
      setSeatCount={setSeatCount}
      columnData={columnData}
      togglePayPeriod={togglePayPeriod}
    />
  ));

  const toggleMonthlyClass = `option ${isMonthly ? 'active' : ''}`;
  const toggleAnnualClass = `option ${isMonthly ? '' : 'active'}`;

  return (
    <div className="v4-billing avo-ui-3">
      <div id="react-pricing">
        <div className="checkout-header width-100 flex-col">
          <p className="fsz-36 pt-25 mb-5 center bold-900">Choose the plan that&apos;s right for you</p>
          <p className="align-self-c center fsz-16 gray" style={{ maxWidth: '510px' }}>
            Whether you are a solo-entrepreneur, growing start-up, or thriving enterprise,
            there is a plan for you.
          </p>
        </div>
        <button type="button" className="switch mt-35" onClick={handleToggle}>
          <p className={toggleMonthlyClass}>Pay Monthly</p>
          <p className={toggleAnnualClass}>Pay Annually</p>
        </button>
        <div style={{ marginBottom: '45px', transform: 'translate(120%, 10px)' }}>
          <img src={arrow} alt="arrow" />
          &nbsp;
          <span className="fsz-13 olive-green">Save 18%</span>
        </div>
        <section id="checkout-step-1">
          {columns}
        </section>
        <FeaturesMatrix />
        <GettingStarted />
        <PerksOfAccountBalance />
        <BalanceCalculator />
        <WhichPlan />
        <PricingFAQ />
      </div>
    </div>
  );
};
